import email from './email.js'
import verification from './verification.js'
import gift from './gift.js'
import status from './status.js'
import tracking from './tracking.js'

export default function appReducer(state, action) {
	return {
		email: email(state.email, action),
		verification: verification(state.verification, action),
		gift: gift(state.gift, action),
		status: status(state.status, action),
		tracking: tracking(state.tracking, action)
	}
}
